export enum WorkflowConfigFieldType {
    INPUT = 'input',
    SELECT = 'select',
    ROLE = 'role',
    DATE_RANGE = 'date_range'
}
